<main class="hero is-fullheight">
	<div class="logo-container">
		<img src="/assets/img/logo.svg" class="logo-image" />
	</div>

	<div class="columns is-marginless">
		<!-- First portal -->
		<div class="column calibrations is-relative portal is-flex">
			<div class="columns is-mobile is-centered">
				<div class="column is-half-fullhd is-two-thirds-desktop is-full-mobile has-text-centered">
					<h1 class="title is-1 has-text-uppercase">
						Calibración, calificación & ensayo
					</h1>
					<a routerLink="/calibraciones" class="button is-danger is-medium">
						Ver más
					</a>
				</div>
			</div>
		</div>

		<!-- Second portal -->
		<div class="column security is-relative portal is-flex">
			<div class="columns is-mobile is-centered" style="width: 100%">
				<div class="column is-half-fullhd is-two-thirds-desktop is-full-mobile has-text-centered">
					<h1 class="title is-1 has-text-uppercase">Seguridad & higiene</h1>
					<a routerLink="/seguridad" class="button is-danger is-medium">Ver más</a>
				</div>
			</div>
		</div>
	</div>
</main>
